var exports = {
  "Zp": "xa15a2ab7--45e332--layout",
  "H3": "xa15a2ab7--45e332--in-gallery",
  "Qq": "xa15a2ab7--45e332--text",
  "Kk": "xa15a2ab7--45e332--icon",
};

module.exports = exports;
